import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=19dc4e84&scoped=true"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"
import style0 from "./SupplierList.vue?vue&type=style&index=0&id=19dc4e84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc4e84",
  null
  
)

export default component.exports